module.exports = __webpack_public_path__ + "img/design proposal_demo-01.2f6d239f.jpg";